import React, { useState, useEffect } from 'react';
import fetchGithubProfileData from './githubProfileData'; // Make sure to import your fetch function
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

function CustomCircularProgressBar({ percentage }) {
  return (
    <div style={{ width: '200px', height: '200px' }}>
      <CircularProgressbarWithChildren
        value={percentage}
        strokeWidth={10}
        styles={buildStyles({
          pathColor: '#054da7',
          trailColor: 'rgb(235,235,239,0.5)',
          rotation: 0.63,  // This will make the bar 3/4 circular
        })}
      >
        <div style={{ fontSize: 20, marginTop: -5 }}>
          <strong>{percentage}%</strong>
        </div>
      </CircularProgressbarWithChildren>
    </div>
  );
}

function ScoreAck() {
  return (
    <div className='scoreAckBox'>
      <div className='lowScoreBox'>
        <div className='lowCircle'></div>
        <h4>0 - 50</h4>
      </div>
      <div className='medScoreBox'>
        <div className='medCircle'></div>
        <h4>51 - 89</h4>
      </div>
      <div className='highScoreBox'>
        <div className='highCircle'></div>
        <h4>90 - 100</h4>
      </div>
    </div>
  );
}

function PersonalizedScores({ scores }) {
  return (
    <div className='psContainer'>
      <div className='psBox1'>
        <div className='ps1 ps'>
          <div className='highCircle'></div>
          <h3>Profile</h3>
          <h5 className="psPercentage">{scores.profile}%</h5>
        </div>
        <div className='ps2 ps'>
          <div className='highCircle'></div>
          <h3>Biography</h3>
          <h5 className="psPercentage">{scores.biography}%</h5>
        </div>
        <div className='ps3 ps'>
          <div className='highCircle'></div>
          <h3>Repository Description</h3>
          <h5 className="psPercentage">{scores.repoDescription}%</h5>
        </div>
      </div>
      <div className='psBox2'>
        <div className='ps4 ps'>
          <div className='highCircle'></div>
          <h3>Repository Popularity</h3>
          <h5 className="psPercentage">{scores.repoPopularity}%</h5>
        </div>
        <div className='ps5 ps'>
          <div className='highCircle'></div>
          <h3>Followers and Following</h3>
          <h5 className="psPercentage">{scores.followersFollowing}%</h5>
        </div>
        <div className='ps6 ps'>
          <div className='highCircle'></div>
          <h3>Consistency</h3>
          <h5 className="psPercentage">{scores.consistency}%</h5>
        </div>
      </div>
    </div>
  );
}

function RenderScoreHtml() {
  const [scores, setScores] = useState({
    profile: 0,
    biography: 0,
    repoDescription: 0,
    repoPopularity: 0,
    followersFollowing: 0,
    consistency: 0,
  });
  const searchParams = new URLSearchParams(window.location.search);
  const username = searchParams.get("user");
  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchGithubProfileData(username.trim()); // Replace 'username' with dynamic value or prop
      if (data) {
        const calculatedScores = calculateScores(data);
        setScores(calculatedScores);
      }
    };

    fetchData();
  }, [username]);

  const calculateScores = (data) => {
    const profileScore = data.username ? 100 : 0;
  
    // Bio Score based on length
    const bioLength = data.bio ? data.bio.length : 0;
    let biographyScore = 0;
    if (bioLength > 100) {
      biographyScore = 100;
    } else if (bioLength > 50) {
      biographyScore = 80;
    } else if (bioLength > 20) {
      biographyScore = 60;
    } else {
      biographyScore = 40;
    }
  
    // Repository Description Score
    const reposWithDescriptions = data.repos.filter(repo => repo.description).length;
    const repoDescriptionPercentage = (reposWithDescriptions / data.repos.length) * 100;
    let repoDescriptionScore = 0;
    if (repoDescriptionPercentage === 100) {
      repoDescriptionScore = 100;
    } else if (repoDescriptionPercentage >= 75) {
      repoDescriptionScore = 80;
    } else if (repoDescriptionPercentage >= 50) {
      repoDescriptionScore = 60;
    } else {
      repoDescriptionScore = 40;
    }
  
    // Followers and Following Score
    const totalConnections = data.followers + data.following;
    let followersFollowingScore = 0;
    if (totalConnections > 1000) {
      followersFollowingScore = 100;
    } else if (totalConnections >= 500) {
      followersFollowingScore = 80;
    } else if (totalConnections >= 100) {
      followersFollowingScore = 60;
    } else {
      followersFollowingScore = 40;
    }
  
    // Repository Popularity Score
    const repoPopularityScore = data.repos.length
      ? data.repos.reduce((acc, repo) => acc + (repo.stargazers_count || 0), 0) / data.repos.length
      : 0;
  
    // Consistency Score
    const consistencyScore = data.commit_data.every(repo => repo.commits.length > 0) ? 100 : 50;
    const avgScore = Math.round((profileScore + biographyScore + repoDescriptionScore + repoPopularityScore + followersFollowingScore + consistencyScore)/6);
    return {
      profile: profileScore,
      biography: biographyScore,
      repoDescription: repoDescriptionScore,
      repoPopularity: repoPopularityScore,
      followersFollowing: followersFollowingScore,
      consistency: consistencyScore,
      avgScore: avgScore,
    };
  };  

  return (
    <section className="scoreSection">
      <div className="scoreContainer">
        <h1>Overall Score</h1>
        <div className="circularBarContainer">
          <CustomCircularProgressBar percentage={scores.avgScore}></CustomCircularProgressBar>
        </div>
        <div className="scoreAck">
          <ScoreAck />
        </div>
        <div className="personalizedScores">
          <PersonalizedScores scores={scores} />
        </div>
      </div>
    </section>
  );
}

export default RenderScoreHtml;
